import {Component, inject, Input, OnInit} from '@angular/core';
import {MatCard, MatCardContent, MatCardHeader} from "@angular/material/card";
import {MatButton} from "@angular/material/button";
import {HasPermissionDirective} from "../../../directives/permissions/has-permission";
import {PermissionTypes} from "../../../enum/PermissionTypes";
import {AdminInviteType} from "../../../enum/AdminInviteType";
import {AddNewAdminComponent} from "../../dialogs/add-new-admin/add-new-admin.component";
import {MatDialog} from "@angular/material/dialog";
import {AgGridAngular} from "ag-grid-angular";
import {ColDef, FirstDataRenderedEvent, GridSizeChangedEvent} from "ag-grid-community";
import {IGameQueryResult} from "../../../interfaces/IGameQueryResult";
import {IAdminWithRolesAsString} from "../../../interfaces/IAdminWithRolesAsString";
import {MatTooltip} from "@angular/material/tooltip";
import {AdminUserTables} from "../../../table-definitions/admin-user-tables";
import {UsersService} from "../../../services/users.service";
import {ActiveUserService} from "../../../services/active-user.service";
import {SnackbarService} from "../../../services/snackbar.service";
import {MatIcon} from "@angular/material/icon";
import {UIStateEnum} from "../../../enum/UIStateEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {GameService} from "../../../services/game.service";

@Component({
  selector: 'app-game-admin-users-view',
  standalone: true,
  imports: [
    MatCard,
    MatCardHeader,
    MatButton,
    HasPermissionDirective,
    MatCardContent,
    AgGridAngular,
    MatIcon,
    MatTooltip,
    MatProgressSpinner
  ],
  templateUrl: './game-admin-users-view.component.html',
  styleUrl: './game-admin-users-view.component.css'
})
export class GameAdminUsersViewComponent implements OnInit {

  private matDialog: MatDialog = inject(MatDialog);
  private adminUserTables: AdminUserTables = inject(AdminUserTables);
  private activeUserService: ActiveUserService = inject(ActiveUserService);
  private snackbarService: SnackbarService = inject(SnackbarService);
  private usersService: UsersService = inject(UsersService);
  private gameService: GameService = inject(GameService);
  public uiState = UIStateEnum.ShowData;
  public uiStateForTemplate = UIStateEnum;

  @Input() set gameSetter(gameP: IGameQueryResult) {
    this.chosenGame = gameP;
    let isCrossGame = !this.gameService.activeGame()?.Id;
    // if the active game id is falsy, it is a cross game request
    this.gameAdminColDefs = this.adminUserTables.gameAdminUserTableColDefs(this.chosenGame.Id, isCrossGame);
    this.fetchGameAdmins();
  }

  private chosenGame: IGameQueryResult | null = null;
  public gameAdminUsers: IAdminWithRolesAsString[] = [];
  public gameAdminColDefs: ColDef[] = [];

  permissionTypes = PermissionTypes;

  ngOnInit(): void {
    this.usersService.getUpdatedAdminUsersBehaviorSubject.subscribe({
      next: (res) => {
        if (res) {
          this.fetchGameAdmins();
        }
      }
    })
  }

  private fetchGameAdmins() {
    this.uiState = UIStateEnum.ShowLoading;

    this.usersService.fetchGameAdminsByGameId(this.activeUserService.activeUser().Id, this.chosenGame?.Id!).subscribe({
        next: (res) => {
          this.gameAdminUsers = res;
          this.uiState = UIStateEnum.ShowData;
        },
        error: () => {
          this.snackbarService.openErrorSnackBar('Failed to retrieve game admins. Please try again or contact your system admin.');
          this.uiState = UIStateEnum.ShowData;
        }
      }
    )
  }

  onInviteUserClick() {
    let dialogRef = this.matDialog.open(AddNewAdminComponent, {
      data: {
        inviteType: AdminInviteType.GameAdminInvite,
        game: this.chosenGame
      },
      width: '650px'
    });


    dialogRef.afterClosed().subscribe({
      next:(updateSuccess) => {
        if(updateSuccess) {
          this.fetchGameAdmins();
        }
      }
    })
  }

  gridSizeChanged(params: GridSizeChangedEvent) {
    params.api.sizeColumnsToFit();
  }

  onFirstDataRendered(params: FirstDataRenderedEvent) {
    params.api.sizeColumnsToFit();
  }
}
